module.exports = __webpack_public_path__ + "media/images/cms/img_slide_16-ea127558b9e49a4f080fd02084de334c.jpg";